import { createSlice } from "@reduxjs/toolkit";
import { fetchMonthlySalaryReport } from "./MonthlySalaryReportThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    year: new Date().getFullYear(),
    month: new Date().toLocaleString("default", { month: "long" }),
  },
};

const monthlySalaryReportSlice = createSlice({
  name: "monthlySalaryReport",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMonthlySalaryReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMonthlySalaryReport.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchMonthlySalaryReport.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = monthlySalaryReportSlice.actions;
export default monthlySalaryReportSlice.reducer;
